import axios from "axios";
import { message } from "antd";
import i18n from "src/utils/i18n";

const axiosInstance = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_API_ENPOINT + "/api"
      : "/api",
  timeout: 50000,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  function (config: any) {
    // Do something before request is sent
    config.headers.authorization = `Bearer ${localStorage.getItem("token")}`;
    config.headers.language = `${localStorage.getItem("lang") || "ja"}`;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error?.response?.status === 401) {
      localStorage.removeItem("access_token");
      window.location.href = "/";
    }
    if (error?.response?.data?.error_message) {
      const errorKey = `errors.message.${error?.response?.data?.error_message}`;
      if (i18n.exists(errorKey)) {
        message.error(i18n.t(errorKey));
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
